/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-unused-state */
import * as partnerHierarchyFormSchema from 'schemas/forms/PartnerHierarchyForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import { loadMdmUsers, resetFetched } from 'actions/mdm'
import SubmitButton from 'components/SubmitButton'
import styles from './PartnerHierarchyDisplayForm.scss'
import AutoCompleteInput from 'components/Form/components/AutoCompleteInput'
import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class PartnerHierarchyDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    currentUserId: PropTypes.string.isRequired,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    metaData: PropTypes.object,
    modals: PropTypes.object.isRequired,
    partnerHierarchyForm: PropTypes.object,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    id: 'partnerHierarchyForm',
    title: '',
    handleFormSubmit: null,
    partnerHierarchyForm: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      employeeId: '',
    }
  }

  componentWillMount() {
    const { formFields } = partnerHierarchyFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }
    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.partnerHierarchyForm
    const modalChanged = modalCreated && nextProps.modals.partnerHierarchyForm.show !== this.props.modals.partnerHierarchyForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.partnerHierarchyForm.show
    const modalVisible = modalCreated && nextProps.modals.partnerHierarchyForm.show

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      const partner = this.props.partnerHierarchy.selectedPartner[0]

      this._handleChange('partnerName', partner.Partner_Name)
      if (partner.Counselling_Partner_Name) {
        this._handleChange('counsellingPartner', partner.Counselling_Partner_Name)
      }
      if (partner.Business_Leader_Name) {
        this._handleChange('businessLeader', partner.Business_Leader_Name)
      }
      if (partner.Offering_Portfolio_Leader_Name) {
        this._handleChange('offeringPortfolioLeader', partner.Offering_Portfolio_Leader_Name)
      }
      if (partner.Business_Coo_Name) {
        this._handleChange('businessCOO', partner.Business_Coo_Name)
      }
      if (partner.Offering_Leader_Name) {
        this._handleChange('offeringLeader', partner.Offering_Leader_Name)
      }
      /* if (partner.Market_Leader_Name) {
        this._handleChange('marketLeader', {
          label: `${partner.Market_Leader_Name} (${partner.Market_Leader_UserName})`,
          value: `${partner.Market_Leader_UserName}@deloitte.com.au|${partner.Market_Leader_Employee_Id}`,
        })
      }
       if (partner.Business_Leader_Name) {
        this._handleChange('businessLeader', {
          label: `${partner.Business_Leader_Name} (${partner.Business_Leader_UserName})`,
          value: `${partner.Business_Leader_UserName}@deloitte.com.au|${partner.Business_Leader_Employee_Id}`,
        })
      } */
      if (partner.Client_Industry_Leader_Name) { // this is now called Growth Leader
        this._handleChange('clientIndustryLeader', {
          label: `${partner.Client_Industry_Leader_Name} (${partner.Client_Industry_Leader_UserName})`,
          value: `${partner.Client_Industry_Leader_UserName}@deloitte.com.au|${partner.Client_Industry_Leader_Employee_Id}`,
        })
      }
    }
  }

  getSuggetionList = (value) => {
    if (value.length < 1) {
      return []
    }
    return this.props.metaData.users.map(user => ({
      label: `${user.employeeName} (${user.employeeEmail.split('@')[0]})`,
      value: `${user.employeeEmail}|${user.code}`,
    }))
  }

  _schema = () => {
    const obj = {}
    partnerHierarchyFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const form = this.props.forms[this.props.id]
    const partner = this.props.partnerHierarchy.selectedPartner[0]
    const data = {
      employee_id: partner.employee_id,
      status: partner.status,
      partner_Name: partner.Partner_Name,
      counselling_Partner_Employee_Id: partner.Counselling_Partner_Employee_Id,
      counselling_Partner_Name: partner.Counselling_Partner_Name,
      counselling_Partner_UserName: partner.Counselling_Partner_UserName,
      /* service_area_leader_Employee_Id: partner.Service_Area_Leader_Employee_Id,
      service_area_leader_Name: partner.Service_Area_Leader_Name,
      service_area_leader_UserName: partner.Service_Area_Leader_UserName,
      business_leader_Employee_Id: form.businessLeader.value.value ? form.businessLeader.value.value.split('|')[1] : null,
      business_Leader_Name: form.businessLeader.value.label ? form.businessLeader.value.label.split(' (')[0] : null,
      business_Leader_UserName: form.businessLeader.value.value ? form.businessLeader.value.value.split('|')[0] : null, // email 
      market_Leader_Employee_Id: form.marketLeader.value.value ? form.marketLeader.value.value.split('|')[1] : null,
      market_Leader_Name: form.marketLeader.value.label ? form.marketLeader.value.label.split(' (')[0] : null,
      market_Leader_UserName: form.marketLeader.value.value ? form.marketLeader.value.value.split('|')[0] : null, // email */

      // now called Growth Leader
      client_industry_leader_Employee_Id: form.clientIndustryLeader.value.value ? form.clientIndustryLeader.value.value.split('|')[1] : null,
      client_Industry_Leader_Name: form.clientIndustryLeader.value.label ? form.clientIndustryLeader.value.label.split(' (')[0] : null,
      client_Industry_Leader_UserName: form.clientIndustryLeader.value.value ? form.clientIndustryLeader.value.value.split('|')[0] : null,
      username: partner.username,
      loginname: partner.loginname,
      /* business_Leader_UserName_Prev: partner.Business_Leader_UserName ? `${partner.Business_Leader_UserName}@deloitte.com.au` : null, */
      client_Industry_Leader_UserName_Prev: partner.Client_Industry_Leader_UserName ? `${partner.Client_Industry_Leader_UserName}@deloitte.com.au` : null,
      /* market_Leader_UserName_Prev: partner.Market_Leader_UserName ? `${partner.Market_Leader_UserName}@deloitte.com.au` : null, */
    }

    this.props.dispatch(formSubmit(this.props.id))
    this.props.handleSubmit(data)
  }

  _handleValidation = (name) => {
    const form = this.props.forms[this.props.id]
    const stateValue = {
      field: name,
      data: {
        focus: false,
        error: form[name].value && (!form[name].value.label) ? 'Please select a valid user.' : '',
      },
    }
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleInputValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    this.props.dispatch(formUpdate(this.props.id, stateValue))
    this.props.dispatch(resetFetched())
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
    Create state value obj
    Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSuggestion = (name, value) => {
    this._handleChange(name, value)

    const val = (typeof value === 'object') ? value.label : value
    clearTimeout(this.timeout)
    if (val.length > 2 && this.state.lastQuery !== val) {
      this.timeout = setTimeout(() => {
        this.setState(() => ({ lastQuery: val }))
        this.props.dispatch(loadMdmUsers(val, this.props.currentUserId, true))
      }, 400)
    }
  }

  _handleAfterClick = (name, value) => {
    this._handleChange(name, value)
  }

  diffPeople = (orginalEmployeeId, newFieldValue) => {
    if ((orginalEmployeeId === null) && (!newFieldValue)) {
      return false
    }
    if ((orginalEmployeeId === null) || (!newFieldValue)) {
      return true
    }
    return orginalEmployeeId !== newFieldValue.split('|')[1]
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    const partner = this.props.partnerHierarchy.selectedPartner[0]
    return partner ? this.diffPeople(partner.market_leader_Employee_Id, form.marketLeader.value.value) ||
      this.diffPeople(partner.business_leader_Employee_Id, form.businessLeader.value.value) ||
      this.diffPeople(partner.client_industry_leader_Employee_Id, form.clientIndustryLeader.value.value) : false
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
      metaData,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={this.props.id}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.partnerName}
                    handleChange={this._handleChange}
                    text={form.partnerName.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />
                  <TextInput
                    {...schema.counsellingPartner}
                    handleChange={this._handleChange}
                    text={form.counsellingPartner.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />
                  <TextInput
                    {...schema.businessLeader}
                    handleChange={this._handleChange}
                    text={form.businessLeader.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />                  
                  <TextInput
                    {...schema.offeringPortfolioLeader}
                    handleChange={this._handleChange}
                    text={form.offeringPortfolioLeader.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />
                  <TextInput
                    {...schema.businessCOO}
                    handleChange={this._handleChange}
                    text={form.businessCOO.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />
                  <TextInput
                    {...schema.offeringLeader}
                    handleChange={this._handleChange}
                    text={form.offeringLeader.value}
                    onBlur={this._handleInputValidation}
                    onFocus={this._handleFocus}
                  />
                  { /* <AutoCompleteInput
                    {...schema.marketLeader}
                    hasFetching
                    error={form.marketLeader.error}
                    fetched={metaData.fetched && form.marketLeader.focus}
                    fetching={metaData.isFetching && form.marketLeader.focus}
                    focus={form.marketLeader.focus}
                    handleChange={this._handleSuggestion}
                    handleChangeAfterClick={this._handleAfterClick}
                    minQueryLength={1}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    suggestions={this.getSuggetionList(form.marketLeader.value)}
                    valid={form.marketLeader.valid}
                    value={form.marketLeader.value.label || form.marketLeader.value || ''}
                  />
                  <AutoCompleteInput
                    {...schema.businessLeader}
                    hasFetching
                    error={form.businessLeader.error}
                    fetched={metaData.fetched && form.businessLeader.focus}
                    fetching={metaData.isFetching && form.businessLeader.focus}
                    focus={form.businessLeader.focus}
                    handleChange={this._handleSuggestion}
                    handleChangeAfterClick={this._handleAfterClick}
                    minQueryLength={1}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    suggestions={this.getSuggetionList(form.businessLeader.value)}
                    valid={form.businessLeader.valid}
                    value={form.businessLeader.value.label || form.businessLeader.value}
                  /> */}
                  <AutoCompleteInput
                    {...schema.clientIndustryLeader}
                    hasFetching
                    error={form.clientIndustryLeader.error}
                    fetched={metaData.fetched && form.clientIndustryLeader.focus}
                    fetching={metaData.isFetching && form.clientIndustryLeader.focus}
                    focus={form.clientIndustryLeader.focus}
                    handleChange={this._handleSuggestion}
                    handleChangeAfterClick={this._handleAfterClick}
                    minQueryLength={1}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    suggestions={this.getSuggetionList(form.clientIndustryLeader.value)}
                    valid={form.clientIndustryLeader.valid}
                    value={form.clientIndustryLeader.value.label || form.clientIndustryLeader.value}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText}
                disabled={!this.canSubmit()}
                isLarge
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
      }
        </div>
      </Modal>
    )
  }
}

export default PartnerHierarchyDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerHierarchy/PartnerHierarchyDisplayForm.js